"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyStore = void 0;
/**
 * KeyStores are used by {@link "@near-js/signers".Signer} to sign transactions.
 *
 */
class KeyStore {
}
exports.KeyStore = KeyStore;
